import { useState } from 'react'
import { reloadForUpdate, usePwa } from '@/lib/pwa'
import './UpdateToast.css'

/** "Update available" with Reload. Nothing reloads on its own. */
export function UpdateToast() {
  const ready = usePwa((s) => s.updateReady)
  const [busy, setBusy] = useState(false)
  if (!ready) return null
  return (
    <div className="update" role="status">
      <span>{busy ? 'Updating…' : 'Update available'}</span>
      <button
        type="button"
        className="update__btn"
        disabled={busy}
        onClick={() => {
          setBusy(true)
          void reloadForUpdate()
        }}
      >
        Reload
      </button>
    </div>
  )
}
